import { useQuery } from '@tanstack/react-query'
import { getEventByIdAdmin } from 'api/event'

export const useEventByIdAdmin = (id: string) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['event', id],
        queryFn: () => getEventByIdAdmin(id),
        enabled: !!id,
    })

    return {
        data,
        isLoading,
        error,
        refetch,
    }
}
